import { tileNames, textBlockType } from "../page/TileConstants";

export const TestTomeB = {
	pages: [
		{
			id: "page_ahjsgd367i",
			order: 3,
		},
		{
			id: "page_fyejmsmjd63jd",
			order: 4,
		},
		{
			id: "page_6sjdhf4ss",
			order: 5,
		},
		{
			id: "page_OP1_hgshkuseygf",
			order: 2,
		},
		{
			id: "page_cut_intro",
			order: 1,
		},
	],
	rows: [
		{
			id: "row_cut_intro_a",
			pageId: "page_cut_intro",
			order: 1,
			height: 12,
			flexHeight: true,
		},
		{
			id: "row_8o7345hugk",
			pageId: "page_ahjsgd367i",
			order: 1,
			height: 11,
			flexHeight: false,
		},
		{
			id: "row_jbsdf82hkd",
			pageId: "page_ahjsgd367i",
			order: 2,
			height: 12,
			flexHeight: false,
		},
		{
			id: "row_ufehjfs",
			pageId: "page_ahjsgd367i",
			order: 3,
			height: 12,
			flexHeight: false,
		},
		{
			id: "row_kjsadgf",
			pageId: "page_fyejmsmjd63jd",
			order: 1,
			height: 4,
			flexHeight: false,
		},
		{
			id: "row_sdoiufgy",
			pageId: "page_fyejmsmjd63jd",
			order: 2,
			height: 6,
			flexHeight: false,
		},
		{
			id: "row_fhiuowbs",
			pageId: "page_fyejmsmjd63jd",
			order: 3,
			height: 16,
			flexHeight: false,
		},
		{
			id: "row_lsdfkljss",
			pageId: "page_fyejmsmjd63jd",
			order: 4,
			height: 17,
			flexHeight: false,
		},
		{
			id: "row_ljfgsdtdew",
			pageId: "page_fyejmsmjd63jd",
			order: 5,
			height: 8,
			flexHeight: false,
		},
		{
			id: "row_qoisdf8",
			pageId: "page_fyejmsmjd63jd",
			order: 6,
			height: 8,
			flexHeight: false,
		},
		{
			id: "row_i8723rgf",
			pageId: "page_6sjdhf4ss",
			order: 1,
			height: 13,
			flexHeight: true,
		},
		{
			id: "row_jkhf73452ajkw",
			pageId: "page_6sjdhf4ss",
			order: 3,
			height: 10,
			flexHeight: true,
		},
		{
			id: "row_76dsuysjh",
			pageId: "page_OP1_hgshkuseygf",
			order: 1,
			height: 9,
			flexHeight: true,
		},
		{
			id: "row_76sfkhsssakis",
			pageId: "page_OP1_hgshkuseygf",
			order: 2,
			height: 9,
			flexHeight: true,
		},
		{
			id: "row_jhgfsdghj289723789",
			pageId: "page_OP1_hgshkuseygf",
			order: 3,
			height: 14,
			flexHeight: true,
		},
		{
			id: "row_yueuykw932jh",
			pageId: "page_OP1_hgshkuseygf",
			order: 4,
			height: 6,
			flexHeight: true,
		},
		{
			id: "row_jhsdf673rs00nbv",
			pageId: "page_OP1_hgshkuseygf",
			order: 5,
			height: 9,
			flexHeight: true,
		},
		{
			id: "row_9889wfhg3jhgf",
			pageId: "page_OP1_hgshkuseygf",
			order: 6,
			height: 12,
			flexHeight: true,
		},
		{
			id: "row_7834kjghfskjdg",
			pageId: "page_OP1_hgshkuseygf",
			order: 7,
			height: 9,
			flexHeight: true,
		},
	],
	tiles: [
		{
			id: "tile_ajdaio9a87",
			pageId: "page_ahjsgd367i",
			rowId: "row_8o7345hugk",
			order: 1,
			width: 6,
			height6: 11,
			height12: 7,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "Purple Smoke",
					},
					{
						type: textBlockType.P,
						content:
							"The passageways varied. Some were large enough to fit a ship through, more like a dry dock than a corridor. Some were like the Roci or the Falcon, well fitted to a human form. Some were barely crawl spaces and some as thin as drinking straws. Probably there were others too small for the naked eye to see.",
					},
				],
			},
		},
		{
			id: "tile_8fkhagdfg",
			pageId: "page_ahjsgd367i",
			rowId: "row_8o7345hugk",
			order: 2,
			width: 6,
			type: tileNames.IMAGE.name,
			params: {
				image: "/images/unsplash/camille-couvez-H5PnIYI_1I0-unsplash.jpg",
				imageSize: "cover",
				backgroundColor: "#F2434B",
			},
		},
		{
			id: "tile_jgd7823Ifgdfg",
			pageId: "page_ahjsgd367i",
			rowId: "row_jbsdf82hkd",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,
			params: {
				image: "/images/device-phone-purple-smoke.png",
				imageSize: "contain",
				backgroundColor: "#F2434B",
			},
		},
		{
			id: "tile_hf783s",
			pageId: "page_ahjsgd367i",
			rowId: "row_ufehjfs",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,
			params: {
				image: "/images/device-laptop-purple-smoke.png",
				imageSize: "contain",
				backgroundColor: "#FFF",
			},
		},

		{
			id: "tile_ask75rt43frh3",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_kjsadgf",
			order: 1,
			width: 12,
			height6: 5,
			height12: 4,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "Null States",
					},
					{
						type: textBlockType.P,
						content: "When adding tiles, we can educate users on how to populate it with content.",
					},
				],
			},
		},

		{
			id: "tile_sadlkjgh",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_sdoiufgy",
			order: 1,
			width: 6,
			type: tileNames.GIPHY.name,
			params: {},
		},
		{
			id: "tile_hjfuise7fh",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_sdoiufgy",
			order: 2,
			width: 6,
			type: tileNames.IMAGE.name,
			params: {},
		},
		{
			id: "tile_hjsdfjhsld7fh",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_fhiuowbs",
			order: 1,
			width: 6,
			type: tileNames.FIGMA.name,
			params: {},
		},
		{
			id: "tile_askjdlh3",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_fhiuowbs",
			order: 2,
			width: 6,
			height6: 16,
			height12: 10,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "More care, for more people.",
					},
					{
						type: textBlockType.P,
						content:
							"We help more patients access the healthcare they need by offering affordable monthly payment options.",
					},
					{
						type: textBlockType.H2,
						content: "Approve up to 90% of patients.",
					},
					{
						type: textBlockType.P,
						content:
							"Many patients looking for care are turned away because of increased out-of-pocket costs and unsophisticated credit algorithms. But that doesn’t have to be the case. It’s time to get more people the treatment they deserve.",
					},
				],
			},
		},
		{
			id: "tile_kjdgs5dcd",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_lsdfkljss",
			order: 1,
			width: 6,
			height6: 17,
			height12: 11,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "We've cracked the code",
					},
					{
						type: textBlockType.P,
						content:
							"But that doesn’t have to be the case. It’s time to get more people the treatment they deserve.",
					},
					{
						type: textBlockType.H3,
						content: "Oh…yes we have",
					},
					{
						type: textBlockType.P,
						content:
							"There's no longer a need for providers to turn away patients, offer multiple finance solutions, or try to manage in-house payment plans.",
					},
					{
						type: textBlockType.H3,
						content: "Let's partner!",
					},
					{
						type: textBlockType.P,
						content: "Talk with one of our team members to see how we can help you approve more patients.",
					},
				],
			},
		},
		{
			id: "tile_hlksdjfls",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_lsdfkljss",
			order: 2,
			width: 6,
			type: tileNames.AIRTABLE.name,
			params: {},
		},
		{
			id: "tile_h763trfgfls",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_ljfgsdtdew",
			order: 1,
			width: 12,
			type: tileNames.VIDEO.name,
			params: {},
		},
		{
			id: "tile_h7wiut734gls",
			pageId: "page_fyejmsmjd63jd",
			rowId: "row_qoisdf8",
			order: 1,
			width: 12,
			type: tileNames.TWITTER.name,
			params: {},
		},

		{
			id: "tile_aj8745645",
			pageId: "page_6sjdhf4ss",
			rowId: "row_i8723rgf",
			order: 1,
			width: 6,
			height6: 13,
			height12: 10,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "Tile scaling",
					},
					{
						type: textBlockType.P,
						content: "Let’s walk through some examples so we don’t  need to rely purely on words.",
					},
					{
						type: textBlockType.H3,
						content: "Default",
					},
					{
						type: textBlockType.P,
						content:
							"There's no longer a need for providers to turn away patients, offer multiple finance solutions, or try to manage in-house payment plans.",
					},
					{
						type: textBlockType.H3,
						content: "Crop behavior",
					},
					{
						type: textBlockType.P,
						content:
							"Once an image is cropped, the cropped out data cannot be seen by viewers of, but it is visible to editors in adjust mode.",
					},
				],
			},
		},
		{
			id: "tile_8fnlh97",
			pageId: "page_6sjdhf4ss",
			rowId: "row_i8723rgf",
			order: 2,
			width: 6,
			type: tileNames.IMAGE.name,
			params: {
				image: "/images/device-bubble-image-white-bg.jpg",
				imageSize: "contain",
				backgroundColor: "#fff",
			},
		},
		{
			id: "tile_jgd7_237tyf",
			pageId: "page_6sjdhf4ss",
			rowId: "row_jkhf73452ajkw",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/pretty-bubble.jpg",
			},
		},

		{
			id: "tile_a6pioqsax7",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_76dsuysjh",
			order: 1,
			width: 12,
			height6: 14,
			height12: 9,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: "OP-1",
					},
					{
						type: textBlockType.H3,
						content: "the all-in-one wonder",
					},
					{
						type: textBlockType.P,
						content:
							"OP-1 is the all-in-one portable synthesizer, sampler and controller. with additional features like a built-in fm radio and an assignable g-force sensor for motion controlled effects, there is nothing quite like it. its modular architecture enables endless sound possibilities without making the workflow complicated or distracting. the compact design and real physical interface makes it inspiring to create music, no matter who you are or how experienced you are.",
					},
				],
			},
		},

		{
			id: "tile_76763hgfs",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_76sfkhsssakis",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/t-e/546b56fcbfd5d50200c6ddeb_2048.jpg",
			},
		},

		{
			id: "tile_kisuyfse76we",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_jhgfsdghj289723789",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/t-e/548e3eb1a452d8020012eab8_4096.png",
				imageSize: "contain",
				backgroundColor: "#c7c7ce",
			},
		},

		{
			id: "tile_hsduhfi82i3r",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_yueuykw932jh",
			order: 1,
			width: 12,
			height6: 13,
			height12: 10,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H3,
						content: "super amoled display.",
					},
					{
						type: textBlockType.P,
						content:
							"the vector based graphical user interface is displayed on the brilliant super amoled display running at 60 fps. all graphics run in realtime, so when a modulator is assigned to a synthesizer parameter, you'll see how that specific parameter is animated, telling you exactly what's going on.",
					},
				],
			},
		},

		{
			id: "tile_88932i724g",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_jhsdf673rs00nbv",
			order: 1,
			width: 6,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/t-e/546c5145f450970200d5807a_4096.jpg",
				imageSize: "cover",
				backgroundColor: "#c7c7ce",
			},
		},

		{
			id: "tile_43o87gehlug",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_jhsdf673rs00nbv",
			order: 2,
			width: 6,
			height6: 13,
			height12: 10,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H3,
						content: "16 hours battery life.",
					},
					{
						type: textBlockType.P,
						content:
							"you can travel the atlantic ocean and back again, constantly making music on your OP-1 before it runs out of power. with over 2 years of stand by time, you can pick it up and create whenever you feel for it. charging is easy with the provided cable plugged into any computer or phone charger that has a usb connector.",
					},
				],
			},
		},

		{
			id: "tile_8743tkjhgsgkhs",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_9889wfhg3jhgf",
			order: 1,
			width: 12,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/t-e/op1io1.png",
			},
		},

		{
			id: "tile_jkhgsdkjfgsa78452",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_7834kjghfskjdg",
			order: 1,
			width: 6,
			height6: 9,
			height12: 6,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H3,
						content: "creative add-ons.",
					},
					{
						type: textBlockType.P,
						content:
							"available as an option is a complete range of truly creative OP-1 accessories. like the crank accessory, which lets you hand crank sequencers, the tape and in fact hand crank any parameter of your choice. the fm antenna increases the signal reception for the built-in fm radio. finally, a great for travel, soft-case is available in black.",
					},
				],
			},
		},
		{
			id: "tile_adsqwr2353456",
			pageId: "page_OP1_hgshkuseygf",
			rowId: "row_7834kjghfskjdg",
			order: 2,
			width: 6,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/t-e/548a550e43d4b202004d348d_2048.png",
				imageSize: "cover",
				backgroundColor: "#c7c7ce",
			},
		},

		{
			id: "tile_cut_intro_a",
			pageId: "page_cut_intro",
			rowId: "row_cut_intro_a",
			order: 1,
			width: 6,
			height6: 12,
			height12: 7,
			type: tileNames.TEXT.name,
			params: {
				blocks: [
					{
						type: textBlockType.H1,
						content: `Cut&
						Copy&
						Paste&
						Replace`,
					},
					{
						type: textBlockType.P,
						content:
							"Try selecting a tile and performing common object-editing operations like cut, copy, and paste. Key commands and right-clicking should both work. ",
					},
				],
			},
		},
		{
			id: "tile_cut_intro_b",
			pageId: "page_cut_intro",
			rowId: "row_cut_intro_a",
			order: 2,
			width: 6,
			type: tileNames.IMAGE.name,

			params: {
				image: "/images/cut-copy-paste.svg",
			},
		},
	],
};
